import { WebPage } from "~/components/layout/WebPage";
import { QENDO_LINKS } from "~/constants/environment";

export default function Nutrition() {
    return <WebPage title="Nutrition" uri={QENDO_LINKS.nutrition} />;
}
